import { auth } from '../firebase/config/config'

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:3001/api'

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message)
    this.name = 'ApiError'
  }
}

export async function apiRequest<T>(
  endpoint: string,
  options: RequestInit = {},
): Promise<T> {
  const user = auth.currentUser

  if (!user) {
    throw new ApiError(401, 'User not authenticated')
  }

  const token = await user.getIdToken()

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  })

  const data = await response.json()

  if (!response.ok) {
    throw new ApiError(response.status, data.error || 'API request failed')
  }

  return data.data
}
